import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import styles from "./ChatGenerateSongPage.module.scss";
/** Появление ряда сообщения (ассистент — снизу, пользователь — справа). */
export const assistantRowVariants = {
    hidden: { opacity: 0, y: 10 },
    show: { opacity: 1, y: 0, transition: { duration: 0.28, ease: "easeOut" } },
};
export const userRowVariants = {
    hidden: { opacity: 0, x: 14, y: 4 },
    show: { opacity: 1, x: 0, y: 0, transition: { duration: 0.26, ease: "easeOut" } },
};
/** Контейнер для каскадного (stagger) появления плиток/чипов. */
export const staggerContainer = {
    hidden: {},
    show: { transition: { staggerChildren: 0.05, delayChildren: 0.04 } },
};
/** Отдельная плитка/чип внутри stagger-контейнера. */
export const chipItem = {
    hidden: { opacity: 0, y: 8, scale: 0.96 },
    show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.22, ease: "easeOut" } },
};
/** Три «прыгающие» точки — индикатор «печатает…». */
export const TypingDots = ({ className }) => (_jsx("span", { className: `${styles.typingDots} ${className ?? ""}`, "aria-hidden": "true", children: [0, 1, 2].map((i) => (_jsx(motion.span, { className: styles.typingDot, animate: { opacity: [0.25, 1, 0.25], y: [0, -3, 0] }, transition: { duration: 0.9, repeat: Infinity, delay: i * 0.15 } }, i))) }));
/**
 * Печатает текст посимвольно. Перед началом — короткая пауза с индикатором
 * «печатает…». Для восстановленных сообщений (enabled=false) рендерит сразу.
 */
export const TypedText = ({ text, enabled, className, speed = 16, onTick, }) => {
    const [count, setCount] = useState(() => (enabled ? 0 : text.length));
    const [phase, setPhase] = useState(enabled ? "dots" : "done");
    const onTickRef = useRef(onTick);
    onTickRef.current = onTick;
    useEffect(() => {
        if (!enabled) {
            setCount(text.length);
            setPhase("done");
            return;
        }
        setCount(0);
        setPhase("dots");
        let interval;
        const delay = setTimeout(() => {
            setPhase("typing");
            let i = 0;
            interval = setInterval(() => {
                i += 1;
                setCount(i);
                onTickRef.current?.();
                if (i >= text.length && interval) {
                    clearInterval(interval);
                    setPhase("done");
                }
            }, speed);
        }, 380);
        return () => {
            clearTimeout(delay);
            if (interval)
                clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, text]);
    if (phase === "dots") {
        return _jsx(TypingDots, { className: className });
    }
    return (_jsxs("span", { className: className, children: [text.slice(0, count), phase === "typing" && _jsx("span", { className: styles.caret, "aria-hidden": "true" })] }));
};
